<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">
            Pedidos de Ativos
            <router-link to="/app/sales/pedidoSistema/">
              <l-button wide type="primary" round style="float: right; margin-right: 15px; margin-top: 5px">
                <span class="btn-label">
                  <i class="fa fa-plus"></i>
                </span>
                Criar
              </l-button>
            </router-link>
            <el-button icon="nc-icon nc-zoom-split"
              @click="filtro = true"
              class="pesquisa" 
              circle
              style="font-size: 0.9em; float: right; margin-right: 15px"></el-button>
          </h4>
        </div>
        <el-dialog center :visible.sync="filtro" title="Filtros">
          <card class="row">
              <!-- Status -->
            <div class="col-sm-12">
              <label class="col-sm-6">Status</label>
              <el-select
                class="select-default col-sm-12"
                size="large"
                placeholder="Selecione"
                v-model="statusCupom"
              >
                <el-option
                  v-for="option in status"
                  class="select-danger"
                  :value="option.value"
                  :label="option.label"
                  :key="option.value"
                ></el-option>
              </el-select>
            </div>
              <!-- Produto --> 
            <div class="col-sm-12">
              <label class="col-sm-6">Produto</label>
              <el-select
                class="select-default col-sm-12"
                size="large"
                placeholder="Selecione"
                v-model="productFilter"
              >
                <el-option
                  v-for="option in productsName"
                  class="select-danger"
                  :value="option.id"
                  :label="option.name"
                  :key="option.id"
                ></el-option>
              </el-select>
            </div>
              <!-- Tipo de ação -->
            <div class="col-sm-12">
              <label class="col-sm-6">Tipo de ação</label>
              <el-select
                class="select-default col-sm-12"
                size="large"
                placeholder="Selecione"
                v-model="actionFilter"
              >
                <el-option
                  v-for="option in actionType"
                  class="select-danger"
                  :value="option.value"
                  :label="option.label"
                  :key="option.value"
                ></el-option>
              </el-select>
            </div>
              <!-- Máquinas -->
            <div class="col-sm-12">
              <label class="col-sm-6">Máquina</label>
              <el-select
                class="select-default col-sm-12"
                size="large"
                placeholder="Selecione"
                v-model="maqFilter"
              >
                <el-option
                  v-for="option in machines"
                  class="select-danger"
                  :value="option.id"
                  :label="option.location"
                  :key="option.id"
                ></el-option>
              </el-select>
            </div>
              <!-- Máquinas -->
            <div class="col-sm-12" style=" margin-bottom: 20px">
              <label class="col-sm-6">Colaborador</label>
                <el-autocomplete
                  class="select-default col-sm-12"
                  v-model="ColabName"
                  :fetch-suggestions="querySearchAsync"
                  placeholder="Comece a digitar para pesquisar"
                  @select="handleSelect"
                ></el-autocomplete>
            </div>
          </card>
          <button class="btn btn-danger offset-sm-8" @click="clearFiltro()">Limpar</button>&nbsp;
          <button class="btn btn-success" @click="filtragem()">Filtrar</button>
        </el-dialog>
        <div class="table-responsive table-full-width" v-if="showTable">
          <el-table class="table-striped" :data="tableData" @sort-change="sorting" v-loading="loading" >
          <el-table-column type="expand">
            <template slot-scope="props">
              <p> <b>Criado em:</b>  {{ props.row.created }}  </p>
              <p> <b>Tipo de ação:</b>  {{ props.row.action_type }}  </p>
              <p v-if="props.row.control != null"> <b>Status do produto:</b>  {{ props.row.control}}  </p>
              <!-- <el-button icon="nc-icon nc-zoom-split"
                @click="filtro = true"
                class="pesquisa" 
                circle
                style="font-size: 0.9em; float: right; margin-right: 15px"></el-button> -->
              <el-tooltip class="item" effect="dark" content="Deletar" placement="top-start">
                <a
                  v-if="props.row.status == 'Aguardando'"
                  class="btn btn-danger btn-link btn-xs"
                  style="font-size: 0.9em; float: right; margin-right: -25px"
                  @click="deleteVoucher(props.row)"
                >
                  <i class="fa fa-trash-o"></i>
                </a>
              </el-tooltip>
            </template>
          </el-table-column>
            <el-table-column label="Colaborador" property="customer" min-width="70" />
            <el-table-column label="Filial" property="company_name" min-width="70" v-if="showMatriz" />
            <el-table-column label="Máquina" property="vm_location" min-width="55"  />
            <el-table-column label="Produto" property="product_name" min-width="55"  />
            <el-table-column label="Quantidade" property="quantity" min-width="60" />
            <!-- <el-table-column label="Ações" width="65"> -->

            <el-table-column
              label="Status"
              width="130">
              <template slot-scope="scope">
                <el-tag
                  style="margin-left: -15px"
                  :type="scope.row.status === 'Aguardando' ? 'warning' : 'success'"
                  disable-transitions><a >{{scope.row.status}}</a></el-tag> 
                
                <!-- <el-tag
                  v-else
                  disable-transitions><a >{{scope.row.status}}</a></el-tag>  -->
              </template>
            </el-table-column>
            <el-table-column label="Ultima atualização" property="updated" sortable="custom" />
          </el-table>
          <p class="x-page-links">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-sizes="[10, 15, 20,25]"
              :page-size="100"
              layout="sizes, prev, pager, next,total"
              :total="totalResults">
            </el-pagination>
          </p>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Dropdown,
  Button,
  DropdownMenu,
  DropdownItem,
  Dialog,
  Select,
  DatePicker,
  TimeSelect,
  Option,
  Pagination,
  Tooltip,
  Tag,
  Loading,
  Autocomplete
} from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Table.name]: Table,
    [DatePicker.name]: DatePicker,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Pagination.name]: Pagination,
    [Tooltip.name]: Tooltip,
    [Tag.name]: Tag,
    [Autocomplete.name]: Autocomplete
  },
  data () {
    return {
      filtro: false,
      produto: [],
      tipo: [],
      prateleira: [],
      vendMachine: [],
      date_init: [],
      categories: [],
      category: '',
      order: [],
      actionType: [{label: 'Retirada', value: 'R'},
               {label: 'Devolução', value: 'D'},],
      validoEm: '',
      status: [{label: 'Aguardando', value: 'AGU'},
               {label: 'Entregue', value: 'ENT'} ],
      statusCupom: '',
      productFilter: '',
      actionFilter: '',
      ColabName: '',
      products: [],
      machines: [],
      maqFilter: '',
      showTable: true,
      orderAPI: [],
      totalResults: 30,
      pesquisa: '',
      page: 1,
      pageSize: 10,
      order: false,
      loading: true,
      btnLoading: false,
      sord: '',
    }
  },
  created() {
    // setInterval(function() {
    //   window.location.reload()
    // }, this.$store.state.general.timer)
  },
  mounted () {
    const ciaID = localStorage.getItem('smartmachCiaID')
    if (ciaID) {
      this.getData(ciaID)
    } else {
      this.getData()
    }
    this.getListCompany
  },
  computed: {
    tableData() {
      let order = this.order
      let dateConverted = order.map(v => {
        let created, updated, status , cor, action_type, customer
        if (v.created) {
          created = new Date(v.created).toLocaleString('pt-br')
        }
        if (v.updated) {
          updated = new Date(v.updated).toLocaleString('pt-br')
        }

        if (v.status == 'AGU') {
          status = 'Aguardando'
          cor = 'orange'
        }
        if (v.status == 'ENT') {
          status = 'Entregue'
          cor = 'green'
        } 
        if (v.action_type == "R") {
          action_type = 'Retirada'
        }
        if (v.action_type == 'D') {
          action_type = 'Devolução'
        }

        if (v.customer) {
          customer = v.customer_first_name + ' ' + v.customer_last_name
        }

        return { ...v, created, updated, status , cor, action_type, customer };
      });
      console.log('conver', dateConverted)
      return dateConverted
    },
    getListCompany () {
      this.$store.dispatch("company/list")
    },
    showMatriz () {
      const matriz = localStorage.getItem("parent_company")
      if (matriz != 'null') {
        return true
      } else {
        return false
      }
    },
    productsName() {
      return this.$store.state.products.products;
    },
    showItem() {
      const smartmach = localStorage.getItem("smartmach")
      if (smartmach === 'true') {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    sorting(x) {
      this.loading = true
      var sinal
      console.log('x',x)
      if (x.order === 'descending') {
        sinal = '-'
      } else {
        sinal = ''
      }
      if (x.prop === "data_inicio") {
        x.prop = 'start_date'
      }
      if (x.prop === 'data_fim') {
        x.prop = 'end_date'
      }
      this.sord = sinal + x.prop
      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    filtragem () {
      this.order = this.orderAPI
      var date = []
      this.pesquisa = ''

      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.pesquisa = this.pesquisa + '&company=' + ciaID
      }

      if (this.statusCupom) {
        this.pesquisa = this.pesquisa + '&status=' + this.statusCupom
      }
      if (this.productFilter) {
        this.pesquisa = this.pesquisa + '&product=' + this.productFilter
      }
      if (this.actionFilter) {
        this.pesquisa = this.pesquisa + '&action_type=' + this.actionFilter
      }
      if (this.maqFilter) {
        this.pesquisa = this.pesquisa + '&vm=' + this.maqFilter
      }
      if (this.customerFilter) {
        this.pesquisa = this.pesquisa + '&customer=' + this.customerFilter
      }
      
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
      this.filtro = false;
    },
    clearFiltro() {
      this.produto = "";
      this.statusCupom = ''
      this.productFilter = ''
      this.actionFilter = ''
      this.maqFilter = ''
      this.customerFilter = ''
      this.ColabName = ''
      this.category = ''
      this.validoEm = ''
      this.tipo = "";
      this.prateleira = "";
      this.vendMachine = "";
      this.filtro = false;
      this.page = 1
      this.pesquisa = ''
      this.date_init = []
      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    filterTag(value, row) {
      return row.ativo === value;
    },
    filterTag2(value, row) {
      return row.limit === value;
    },
    handleSizeChange(val) {
      this.loading = true
      this.pageSize = val
      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    handleCurrentChange(val) {
      this.loading = true
      this.page = val
      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },


    querySearchAsync(queryString, cb) {
      var y
      this.$store.dispatch("customers/listSort", {sort: '?first_name__icontains=' + queryString}).then(data => {
        var x = data.map(v => {
          let value, link
          if (v.first_name) {
            value = v.first_name
          }
          link = value
          return {...v, value, link}
          
        })
        console.log('pesq', y)
        y = this.redux(x)
        this.links = y
        var links = this.links;
        var results
        
        results = queryString ? links.filter(this.createFilter(queryString)) : links;
      
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 600);
        })
    },

    redux(x) {
      var seenNumber = {};

      var fil = x.filter(function(
        currentObject
      ) {
        if (currentObject.status in seenNumber) {
          return false;
        } else {
          seenNumber[currentObject.status] = true;
          return true;
        }
      });
      return fil;
    },

    createFilter(queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      this.colabName = item.first_name
      this.customerFilter = item.id
    },
    deleteVoucher (data) {
      console.log('dele', data)
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a excluir esse pedido de Ativo.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, exclua!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("ownOrder/delete", { id: data.id }).then(() =>{
            swal.fire({
              title: "Pronto!",
              text: `Ativo excluído.`,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            }).then(result =>{
              const ciaID = localStorage.getItem('smartmachCiaID')
              if (ciaID) {
                this.getData(ciaID)
              } else {
                this.getData()
              }
            })
          });
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `Ativo não excluído.`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    getData (id) {
      this.loading = true
      if (id) { 
        id = id
      } else {
        id = ''
      }
      this.$store.dispatch("ownOrder/listSort", {sort: '?page_size=' + this.pageSize
        + '&page=' + this.page + '&company=' + id +
        '&ordering=' + this.sord + this.pesquisa}).then(resp => {
        this.totalResults = this.$store.state.ownOrder.page.count
        console.log('rest', resp)
        this.order = resp
        this.orderAPI = resp
        this.loading = false
        this.tableData
      }).catch(err => console.log(err));
      this.$store.dispatch("products/listSort",{sort: '?company=' + id}).catch(err => console.log(err));
      this.$store.dispatch("machines/listSort",{sort: '?page_size=300'  + '&company=' + id}).then(data =>{
        this.machines = data
        this.$store.dispatch('lockers/listSort', {sort: '?page_size=300'  + '&company=' + id}).then(resp => {
          for (let index = 0; index < resp.length; index++) {
            this.machines.push(resp[index])
            console.log('machines', this.machines)
          }
        })
      })

    },
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
/* .card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
} */
.x-page-links {
  margin-top: 15px;
  text-align: center;
}
.x-page-links span {
  cursor: pointer;
  margin: 0 10px;
}
.el-pagination__total {
    float: right;
    text-align: end;
    font-weight: 400;
    color: #606266;
}
.pesquisa {
    font-size: 0.9em;
    float: right;
    margin-right: 15px;
}
</style>
